import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseApiService } from '@core/api/base-api.service';
import { FeatureDetailDto } from '../models/rbac.model';

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private readonly api = inject(BaseApiService);
  private readonly base = 'v1/admin/rbac';

  getFeatureDetails(): Observable<readonly FeatureDetailDto[]> {
    return this.api.get<readonly any[]>(`${this.base}/feature-details`).pipe(
      map((arr) =>
        (Array.isArray(arr) ? arr : []).map((fd) => ({
          featureDetailId: Number(fd?.featureDetailId ?? fd?.id ?? 0),
          featureId: Number(fd?.featureId ?? 0),
          name: String(fd?.name ?? ''),
          description: String(fd?.description ?? ''),
          defaultMatrix: fd?.defaultMatrix ?? {},
          deletedAt: fd?.deletedAt ?? null,
          createdAt: String(fd?.createdAt ?? ''),
        })),
      ),
    );
  }
}
